import { useEnterStore } from 'hooks/stores/useEnterStore';
import { observer } from 'mobx-react-lite';
import { colors } from 'utils/constants';
import { EntryMethodDetails } from '../EntryMethod';
import BoostJackpotSectionV2 from './BoostJackpotSectionV2';

export const BoostJackpotEnter = observer(() => {
  const { entryMethod, dayEnabled, boosted, setBoosted, boostCostPerEntry } =
    useEnterStore();

  return (
    <BoostJackpotSectionV2
      additionalClassName={'!border-none h-[150px] px-2'}
      style={{ background: colors.footerBackground }}
      entryMethod={entryMethod}
      boostCostPerEntry={boostCostPerEntry}
      boostJackpot={boosted}
      setBoostJackpot={setBoosted}
      glowColor={
        entryMethod
          ? EntryMethodDetails[entryMethod].underlineGlowColor
          : '#95F5DE'
      }
      onAnyUserAction={() => {}}
      disabled={undefined}
      replaceSwitchWithLoadingSpinner={undefined}
      collapsible={undefined}
      noIcon={undefined}
    />
  );
});
